// 足球 联赛 CSL 顶部菜单

module.exports = {
  menuSeasonName: '中国足球协会超级联赛',
  sportType: 'football',
  menuData: [
    {
      name: 'webMenu',
      arr: [
        // {
        //   name: '概述',
        //   key: 'summary',
        //   act: true,
        // },
        {
          name: '赛程',
          key: 'schedule',
          routeName: 'scheduleIndex_FBLCSL',
          act: true,
        },
        {
          name: '球队排名',
          key: 'teamRank',
          routeName: 'teamRankIndex_FBLCSL',
          act: false,
        },
        {
          name: '球队',
          key: 'team',
          routeName: 'teamIndex_FBLCSL',
          act: false,
        },
        {
          name: '球员',
          key: 'player',
          routeName: 'playerIndex_FBLCSL',
          act: false,
        },
        {
          name: '数据中心',
          key: 'record',
          routeName: 'recordDetailIndex_FBLCSL',
          act: false,
          child: [
            {
              name: '数据概览',
              key: 'dataOverview',
              act: false,
              routeName: 'recordDetailDataOverview_FBLCSL',
            },
            {
              name: '球队数据',
              key: 'teamData',
              act: false,
              routeName: 'recordDetailTeamData_FBLCSL',
            },
            {
              name: '球员数据',
              key: 'playerData',
              act: false,
              routeName: 'recordDetailPlayerData_FBLCSL',
            },
            {
              name: '阵容数据',
              key: 'lineupData',
              act: false,
              routeName: 'recordDetailLineupData_FBLCSL',
            },
          ],
        },
        {
          name: '场馆',
          key: 'sportsHall',
          routeName: 'sportsHallIndex_FBLCSL',
          act: false,
        },
      ],
    },
    {
      name: 'openMenu',
      arr: [
        {
          name: '节目单',
          key: 'programList',
          routeName: 'programListIndex_FBLCSL',
          act: false,
          isOpenWeb: true,
        },
        {
          name: '播出单',
          key: 'broadcastList',
          routeName: 'broadcastListIndex_FBLCSL',
          act: false,
          isOpenWeb: true,
        },
        {
          name: '数据包装',
          key: 'dataPackagList',
          routeName: 'dataPackagListIndex_FBLCSL',
          act: false,
          isOpenWeb: true,
        },
      ],
    },
  ],
}
